<template>
  <div>
    <button
      v-show="expanded"
      class="collapse"
      @click="collapse">
      <icon-section-collapse />
    </button>
    <button
      v-show="!expanded"
      class="expand"
      @click="expand">
      <icon-section-expand />
    </button>
  </div>
</template>

<script>
  import { IconSectionCollapse, IconSectionExpand } from '@/common/icons/monochrome';

  export default {
    components: {
      IconSectionCollapse,
      IconSectionExpand,
    },
    props: ['expanded'],
    methods: {
      expand() {
        this.$emit('expanded');
      },
      collapse() {
        this.$emit('collapsed');
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  div {
    float: right;

    button {
      display: inline-block;
      background: transparent;
      border: none;

      svg {
        stroke: var(--textColor);

        width: 1.6rem;
        height: 1.6rem;
      }
    }
  }
</style>
